import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { HcaBrandService } from '../../../../../../shared/_services/hca-brand.service';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { Subscription, Subject } from 'rxjs';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { GetJsonService } from '../../../../../../shared/_services/get-json.service';

@Component({
  selector: 'app-loyalty-website-other-pages',
  templateUrl: './loyalty-website-other-pages.component.html',
  styleUrls: ['./loyalty-website-other-pages.component.scss']
})
export class LoyaltyWebsiteOtherPagesComponent implements OnInit {
  howitworksFormEn: FormGroup;
  howitworksFormEs: FormGroup;
  earnpointsFormEn: FormGroup;
  earnpointsFormEs: FormGroup;
  spendpointsFormEn: FormGroup;
  spendpointsFormEs: FormGroup;
  isDirtyEn: boolean = false;
  isDirtyEs: boolean = false;
  spanish: any;
  english: any;
  brand: any;
  languages: any;
  hotelBrands: any;
  errorDetails: any;
  successMsg: string;
  statusModal: BsModalRef;
  private subscription: Subscription;
  private unsubscribe: Subject<void> = new Subject<void>();
  howitworksHtml = "<!---- Template ----> \n\n<div class='container-fluid'>\n  <div class='row'>\n    <div class='col earn-points-container text-center pt-5'>\n      <h1 class='heading'>HOW IT WORKS</h1>\n      <P class='sub-heading p-0'>Get rewarded by being a Sandos4U loyalty member</P>\n      <div class='container card-container'>\n        <div class='row'>\n          <div class='col'>\n            <div class='card custom-card'>\n              <div class='img-container'>\n                <img src='assets/images/icon-book.png' class='image-reponsive card-img-top mx-auto' />\n              </div>\n              <div class='card-body'>\n                <h4 class='card-title custom-card-title'>Book a stay directly through Sandos</h4>\n                <p class='card-text custom-card-text'>Supporting Sentence</p>\n              </div>\n            </div>\n            <div class='card custom-card'>\n              <div class='img-container'>\n                <img src='assets/images/phone.png' class='image-reponsive card-img-top mx-auto phone-img' />\n              </div>\n              <div class='card-body'>\n                <h4 class='card-title custom-card-title'>Book indirectly from a third party</h4>\n                <p class='card-text custom-card-text'>Supporting Sentence</p>\n              </div>\n            </div>\n            <div class='card custom-card mr-0'>\n              <div class='img-container'>\n                <img src='assets/images/asset-1.png' class='image-reponsive card-img-top mx-auto asset-img' />\n              </div>\n              <div class='card-body'>\n                <h4 class='card-title custom-card-title'>Earn points for spending money during your stay</h4>\n                <p class='card-text custom-card-text'>Supporting Sentence</p>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class='row'>\n          <div class='col text-center'>\n            <button class='btn btn-default btn-card'>See more ways to Earn Points</button>\n          </div>\n        </div>\n        <div class='row'>\n          <div class='col'>\n            <h1 class='heading'>HOW TO USE SANDOS COINS</h1>\n            <P class='sub-heading p-0'>The process to use your Sandos Coins is easy and transparent. As a Sandos4U member, you always know how many\n              coins you have and how to apply them. Here's what you can get:</P>\n          </div>\n        </div>\n        <div class='row'>\n          <div class='col'>\n            <div class='card custom-coins-card'>\n              <img src='assets/images/card.svg' class='mx-auto coins-img' />\n              <div class='card-body custom-card-body'>\n                <h4 class='card-title custom-title'>Discount Galore</h4>\n                <p class='card-text custom-card-text'>The more you earn, the more you can save on future bookings and resort activities.</p>\n              </div>\n            </div>\n            <div class='card custom-coins-card mr-0'>\n              <img src='assets/images/asset-11.png' class='mx-auto coins-img' />\n              <div class='card-body custom-card-body'>\n                <h4 class='card-title custom-title'>Relaxation Made Easy</h4>\n                <p class='card-text custom-card-text'>Spend coins on a massage or spa package</p>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class='row'>\n          <div class='col membership-container'>\n            <h1 class='heading'>SANDOS4U MEMBERSHIP LEVELS + PERKS</h1>\n            <P class='sub-heading p-0'>An overview of Sandos4u Membership Options</P>\n            <div class='table-responsive-sm'>\n              <table class='table table-bordered'>\n                <thead class='custom-thead'>\n                  <tr>\n                    <th>Membership Benefit</th>\n                    <th>Blue</th>\n                    <th>Gold</th>\n                    <th>Platinum</th>\n                  </tr>\n                </thead>\n                <tbody class='text-left'>\n                  <tr>\n                    <td>Earn Coins for Direct Bookings</td>\n                    <td>\n                      <div class='coins mx-auto'></div>\n                    </td>\n                    <td>\n                      <div class='coins mx-auto'></div>\n                    </td>\n                    <td>\n                      <div class='coins mx-auto'></div>\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>Access to Room Upgrades</td>\n                    <td>\n                      <div class='coins mx-auto'></div>\n                    </td>\n                    <td>\n                      <div class='coins mx-auto'></div>\n                    </td>\n                    <td>\n                      <div class='coins mx-auto'></div>\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>Ability for late check-out</td>\n                    <td>\n                      <div class='coins mx-auto'></div>\n                    </td>\n                …2' /><label for='c2'></label>\n              </button>\n              <span >What is Sandos4u?</span>\n              <div id='a2' class='collapse'>\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n              </div>\n            </div>\n            <div class='question'>\n              <button type='button' class='btn btn-plus' data-toggle='collapse' data-target='#a3'>\n                <!-- <img src='assets/images/plus-light-dark.svg' /> -->\n                <input type='checkbox' id='c3' /><label for='c3'></label>\n              </button>\n              <span >How do I become a M4U Member?</span>\n              <div id='a3' class='collapse'>\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n              </div>\n            </div>\n            <div class='question'>\n              <button type='button' class='btn btn-plus' data-toggle='collapse' data-target='#a4'>\n                <!-- <img src='assets/images/plus-light-dark.svg' /> -->\n                <input type='checkbox' id='c4' /><label for='c4'></label>\n              </button>\n              <span >How do I become a Sandos4u Member?</span>\n              <div id='a4' class='collapse'>\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n              </div>\n            </div>\n            <div class='question'>\n              <button type='button' class='btn btn-plus' data-toggle='collapse' data-target='#a5'>\n                <!-- <img src='assets/images/plus-light-dark.svg' /> -->\n                <input type='checkbox' id='c5' /><label for='c5'></label>\n              </button>\n              <span >How do I earn my M4U points?</span>\n              <div id='a5' class='collapse'>\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n              </div>\n            </div>\n            <div class='question'>\n              <button type='button' class='btn btn-plus' data-toggle='collapse' data-target='#a6'>\n                <!-- <img src='assets/images/plus-light-dark.svg' /> -->\n                <input type='checkbox' id='c6' /><label for='c6'></label>\n              </button>\n              <span >How do I earn my Sandos4u points?</span>\n              <div id='a6' class='collapse'>\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n              </div>\n            </div>\n            <div class='question'>\n              <button type='button' class='btn btn-plus' data-toggle='collapse' data-target='#a7'>\n                <!-- <img src='assets/images/plus-light-dark.svg' /> -->\n                <input type='checkbox' id='c7' /><label for='c7'></label>\n              </button>\n              <span>What are the benefits of becoming M4U member?</span>\n              <div id='a7' class='collapse'>\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n              </div>\n            </div>\n            <div class='question'>\n              <button type='button' class='btn btn-plus' data-toggle='collapse' data-target='#a8'>\n                <!-- <img src='assets/images/plus-light-dark.svg' /> -->\n                <input type='checkbox' id='c8' /><label for='c8'></label>\n              </button>\n              <span >What are the benefits of becoming Sandos4u member?</span>\n              <div id='a8' class='collapse'>\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.\n                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class='row'>\n    <div class='col text-center p-4'>\n      <img src='assets/images/sandos-logo-72@2x.png'/>\n    </div>\n  </div>\n</div>\n\n<!---- Template ---->";
  howitworksCss = "/* ------Template ---- */ \n\n.earn-points-container{\n    background-color: #fffdf9;\n}\n.earn-points-container .heading{\n    font-size: 36px;\n    color: #38b9ff;\n    line-height: 54px;\n}\n.earn-points-container .sub-heading{\n    font-size: 20px;\n    color:#0c0033;\n    opacity: 0.5;\n    line-height: 28px;\n    border: none;\n    margin: 0;\n    margin-bottom: 16px;\n    background: none;\n}\n.earn-points-container .card-container{\n    padding: 10px;\n}\n.earn-points-container .custom-card{\n    width: 100%;\n    height: 288px;\n    float: left;\n    margin-right: 30px;\n    padding-top: 30px;\n    margin-bottom:30px;\n}\n.earn-points-container .custom-card img{\n    width:189px;\n    height: 130px;\n}\n.earn-points-container .custom-card img.phone-img{\n    width:120px;\n    height: 120px;\n}\n.earn-points-container .custom-card img.asset-img{\n    width:180px;    \n}\n.earn-points-container .custom-card .custom-card-title{\n    min-height: 48px;\n    font-weight: bold;\n    font-size: 20px;\n}\n.earn-points-container .custom-card-text{\n    font-size: 16px;\n    opacity: 0.5;\n    border: none;\n    background: none;\n    color: #0c0033;\n    margin: 0;\n    padding: 0;\n    font-weight: 600;\n}\n.earn-points-container .custom-card .img-container{\n    height: 200px;\n}\n.earn-points-container .card-container .btn-card{\n    width:290px;\n    height: 40px;\n    background: #f37b20;\n    color:#fff !important;\n    margin:3px 0 70px 0;\n}\n.earn-points-container .card-container .btn-card:focus{\n    box-shadow: none;\n}\n.earn-points-container .card-container .custom-coins-card{\n    width:100%;\n    height: 288px;\n    float: left;\n    margin-right:30px;\n    margin-bottom:30px;\n    // padding: 5px 30px;\n    \n}\n.earn-points-container .card-container .custom-coins-card .coins-img{\n    // width: 136px;\n    height: 179px;    \n}\n.earn-points-container .card-container .custom-coins-card .custom-card-body{\n    padding: 0 20px;\n}\n.earn-points-container .card-container .custom-coins-card .custom-card-body .custom-title{\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 24px;\n}\n// .earn-points-container .card-container .custom-coins-card .custom-card-body .custom-text{\n//     font-size: 16px;\n//     opacity: 0.5;\n//     line-height: 24px;\n//     color: #0c0033;\n//     border: none;\n//     background: none;\n//     padding: 0;\n//     margin: 0;\n// }\n.earn-points-container .card-container .membership-container{\n    padding:15px;\n}\n.earn-points-container .card-container .membership-container .table-bordered td{\n    border: solid 1px rgba(74, 74, 74, 0.25);\n}\n.earn-points-container .card-container .membership-container .custom-thead{\n    background: #f37b20;\n    color: rgba(255, 255, 255, 0.75);\n    font-size: 16px;\n}\n.earn-points-container .card-container .membership-container .custom-thead th{\n    font-weight: normal;\n    border: none;\n    width:15%;\n}\n.earn-points-container .card-container .membership-container .custom-thead th:first-child{\n    width:55%;\n}\n.earn-points-container .card-container .membership-container tbody{\n    font-size: 16px;\n    color:rgba(12, 0, 51, 0.5);\n    font-weight: 600;\n}\n.earn-points-container .card-container .membership-container tbody tr:nth-of-type(even){\n    background: #fff9f0;\n}\n.earn-points-container .card-container .membership-container .coins{\n    width:16px;\n    height: 16px;\n    border-radius: 50%;\n    background-color: #66a8d4;\n    margin: 0 auto;\n}\n.earn-points-container .card-container .faq-container{\n    padding:30px 15px;\n}\n.earn-points-container .card-container .faq-container h4{\n    color: #38b9ff;\n    line-height: 32px;\n    font-size: 20px;\n}\n.earn-points-container .card-container .faq-container .btn-plus{\n    background: none !important;\n    padding: 0;\n    margin: 6px 12px;\n    font-size: 16px;\n    border: none;\n}\n.earn-points-container .card-container .faq-container .btn-plus img{\n    width:18px;\n    height: 18px;\n    vertical-align: top\n}\n.earn-points-container .card-container .faq-container .btn-plus:focus{\n    box-shadow:none;\n}\n.earn-points-container .card-container .faq-container .question{\n    font-size: 14px;\n    color: #0c0033;\n    opacity: 0.5;\n    padding: 5px 0;\n}\n.earn-points-container .card-container .faq-container input[type='checkbox'] {\n    display: none;\n}\n.earn-points-container .card-container .faq-container label {\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    background: url('/assets/images/plus-light-dark.svg') no-repeat;\n    margin: 0;\n    vertical-align: text-bottom;\n}\n.earn-points-container .card-container .faq-container input[type='checkbox']:checked + label {\n    background: url('/assets/images/minus.svg') no-repeat 0 8px;\n}\n@media (min-width: 991px){\n    .earn-points-container .card-container{\n        padding: 10px 105px;\n    }\n    .earn-points-container .custom-card{\n        width:288px;\n    }\n    .earn-points-container .card-container .custom-coins-card{\n        width:450px;\n    }\n    .earn-points-container .card-container .custom-coins-card{\n        padding: 5px 30px;\n    }\n}\n\n/* ------Template ---- */";

  constructor(
    private hcaUserManagementService: HcaUserManagementService,
    private hotelManagementService: HotelManagementService,
    private hcaBrandService: HcaBrandService,
    private loyaltyService: LoyaltyService,
    public modalService: BsModalService,
    public translate: TranslateService,
    private getJsonService: GetJsonService,
    private fb: FormBuilder,
  ) { 
    let user = JSON.parse(localStorage.getItem('loggedInUser'));
    translate.setDefaultLang('en');
    translate.use('en');
    this.modalService.onHide
    .takeUntil(this.unsubscribe).subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.type == "hca-wizard") {
          if (this.statusModal.content.srcObject.action == "action1") {
            this.howitworksFormEn.patchValue(this.howitworksFormEn.get('resetData').value, { emitEvent: false });
            this.howitworksFormEs.patchValue(this.howitworksFormEs.get('resetData').value, { emitEvent: false });
          }
        }
        if (this.statusModal.content.srcObject.type == "hca-other-pages") {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.isDirtyEn == true) {
              this.isDirtyEn = false;
              setTimeout(() => {
                this.getOtherPages(this.brand.brandId);
                let element = document.getElementById("spanishOther");
                element.click();
              }, 50);
            }
            if (this.isDirtyEs == true) {
              this.isDirtyEs = false;
              setTimeout(() => {
                this.getOtherPages(this.brand.brandId);
                let element = document.getElementById("englishOther");
                element.click();
              }, 50);
            }
          }
        }
      }
    })
  }

  resetField(field?, form?) {
    if (field && form) {
      this[form].controls[field].patchValue(this[form].controls['resetData'].value[field], { emitEvent: false });
    }
  }

  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  getLanguageCodes() {
    this.hcaBrandService.getLanguageCodes().subscribe(
      res => {
        if (res.error == 0) {
          this.languages = res.responseObj;
          console.log("Get Languages : " + res.responseObj);
          if (res.responseObj.length > 0) {
          }
        }
        else {
          console.error("Get Languages : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  saveForm(){
    let formData = {
      brandId: this.hotelManagementService.getSelectedBrand().brandId,
      howItWorksToList: [this.howitworksFormEn.value, this.howitworksFormEs.value],
      earnPoints: [this.earnpointsFormEn.value, this.earnpointsFormEs.value],
      spendPoints: [this.spendpointsFormEn.value, this.spendpointsFormEs.value]
    }
    console.log(formData);
    this.loyaltyService.saveLoyaltyWebsiteOtherPages(formData).subscribe(res => {
      this.isDirtyEn = false;
      this.isDirtyEs = false;
      console.log(res);
      this.successMsg = 'Saved successfully';
      setTimeout(() => {
        this.successMsg = '';
      }, 1500);
    }, err => {
      console.error('Error Saving', err.message);
      setTimeout(() => {
        this.errorDetails = '';
      }, 1500);
    })

  }

  getOtherPages(brandId) {
    this.initForm('en');
    this.initForm('es');
    this.loyaltyService.getOtherPages(brandId).subscribe(res => {
      console.log('=========== other pages data ========', res);
      if (res.error == 0) {
        if (res.responseObj && res.responseObj.howItWorksToList.length) {
          res.responseObj.howItWorksToList.forEach(data => {
            if (data.languageId == 1) {
              console.log('=========== other   ========', data);
              this.initForm(data, 'en');
            }
            if (data.languageId == 2) {
              console.log('=========== other pages  ========', data);
              this.initForm(data, 'es');
            }
          })
        }
        if (res.responseObj && res.responseObj.earnPoints.length) {
          res.responseObj.earnPoints.forEach(data => {
            if (data.languageId == 1) {
              console.log('=========== other earnPoints   ========', data);
              this.initForm1(data, 'en');
            }
            if (data.languageId == 2) {
              console.log('=========== other earnPoints  ========', data);
              this.initForm1(data, 'es');
            }
          })
        }
        if (res.responseObj && res.responseObj.spendPoints && res.responseObj.spendPoints.length) {
          res.responseObj.spendPoints.forEach(data => {
            if (data.languageId == 1) {
              console.log('=========== other spendPoints   ========', data);
              this.initForm2(data, 'en');
            }
            if (data.languageId == 2) {
              console.log('=========== other spendPoints  ========', data);
              this.initForm2(data, 'es');
            }
          })
        }
      }
    }, err => {
      console.error('Error fetching loyalty catalog banner', err);
    })
  }

  initForm(data?: any, lang?) {
    if (lang == 'en') {
      let defaultData = {
        howitworksHtml: this.howitworksHtml,
        howitworksCss: this.howitworksCss,
      }
      this.howitworksFormEn = this.fb.group({
        languageId: [1],
        howitworksHtml: [data ? data.howitworksHtml : this.howitworksHtml],
        howitworksCss: [data ? data.howitworksCss : this.howitworksCss],
        resetData: [data ? data : defaultData]
      })
      this.howitworksFormEn.valueChanges.subscribe(data => {
        if (this.howitworksFormEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (lang == 'es') {
      let defaultData = {
        howitworksHtml: this.howitworksHtml,
        howitworksCss: this.howitworksCss,
      }
      this.howitworksFormEs = this.fb.group({
        languageId: [2],
        howitworksHtml: [data ? data.howitworksHtml : this.howitworksHtml],
        howitworksCss: [data ? data.howitworksCss : this.howitworksCss],
        resetData: [data ? data : defaultData]
      })
      this.howitworksFormEs.valueChanges.subscribe(data => {
        if (this.howitworksFormEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }
  }

  initForm1(data?: any, lang?) {
    if (lang == 'en') {
      this.earnpointsFormEn = this.fb.group({
        languageId: [1],
        header: [data ? data.header : ''],
        subheader: [data ? data.subheader : '']
      })
      this.earnpointsFormEn.valueChanges.subscribe(data => {
        if (this.earnpointsFormEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (lang == 'es') {
      this.earnpointsFormEs = this.fb.group({
        languageId: [2],
        header: [data ? data.header : ''],
        subheader: [data ? data.subheader : '']
      })
      this.earnpointsFormEs.valueChanges.subscribe(data => {
        if (this.earnpointsFormEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }

  }

  initForm2(data?: any, lang?) {
    if (lang == 'en') {
      this.spendpointsFormEn = this.fb.group({
        languageId: [1],
        heading: [data ? data.heading : ''],
        subHeading: [data ? data.subHeading : '']
      })
      this.spendpointsFormEn.valueChanges.subscribe(data => {
        if (this.spendpointsFormEn.dirty) {
          this.isDirtyEn = true;
          console.log("en dirty " + this.isDirtyEn);
        }
        else {
          this.isDirtyEn = false;
        }
      });
    }
    if (lang == 'es') {
      this.spendpointsFormEs = this.fb.group({
        languageId: [2],
        heading: [data ? data.heading : ''],
        subHeading: [data ? data.subHeading : '']
      })
      this.spendpointsFormEs.valueChanges.subscribe(data => {
        if (this.spendpointsFormEs.dirty) {
          this.isDirtyEs = true;
          console.log("es dirty " + this.isDirtyEs);
        }
        else {
          this.isDirtyEs = false;
        }
      });
    }

  }

  initialise() {
    if (this.isDirtyEn == true) {
      this.cancel("english");
    }
    else if (this.isDirtyEs == true) {
      this.cancel("spanish");
    }
  }

  cancel(language) {
    let title = "";
    let status = "";
    let message = "";
    let action1 = "";
    let action2 = "";
    if (language == "english") {
      title = this.english.MODAL.CONFIRM;
      status = this.english.MODAL.ACTIVE;
      message = this.english.MODAL.NOT_SAVED;
      action1 = this.english.MODAL.YES;
      action2 = this.english.MODAL.NO;
    }
    else {
      title = this.spanish.MODAL.CONFIRM;
      status = this.spanish.MODAL.ACTIVE;
      message = this.spanish.MODAL.NOT_SAVED;
      action1 = this.spanish.MODAL.YES;
      action2 = this.spanish.MODAL.NO;
    }

    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-other-pages',
      title: title,
      status: status,
      message: message,
      action1: action1,
      action2: action2,
      action: '',
      style: 'active'
    }
  }

  getEnglishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "en.json")
      .subscribe(
      (res) => {
        this.english = res;
        console.log("English Translations: " + res);
      },
      (err) => console.error("English Translations" + err));

  }
  getSpanishTranslations() {
    this.getJsonService.getJSON("../assets/i18n/", "es.json")
      .subscribe(
      (res) => {
        this.spanish = res;
        console.log("Spanish Translations: " + res);
      },
      (err) => console.error("Spanish Translations" + err));
  }

  ngOnInit() {
    this.getHotelBrandsByHotelChain();
    this.getLanguageCodes();
    this.subscription = this.loyaltyService.brandState
      .subscribe((state: any) => {
        this.brand = state.brand;
        this.getOtherPages(this.brand.brandId);
      });
    this.initForm(null, 'en');
    this.initForm(null, 'es');
    this.initForm1(null, 'en');
    this.initForm1(null, 'es');
    this.initForm2(null, 'en');
    this.initForm2(null, 'es');
    this.getEnglishTranslations();
    this.getSpanishTranslations();
  }

  ngAfterViewInit() {
    this.brand = this.hotelManagementService.getSelectedBrand();
    this.getOtherPages(this.brand ? this.brand.brandId : null);

  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/loyalty-website-other-pages/loyalty-website-other-pages.component.ts